import { set, get, del } from 'idb-keyval';

export const getFromStorage = (key: string): Promise<any> => {
  return get(key);
};

export const setInStorage = (key: string, value: any): Promise<void> => {
  return set(key, value);
};

export const removeFromStorage = (key: string): Promise<void> => {
  return del(key);
};
